/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';

import { MapsAPILoader } from '@agm/core';
// import { } from '@types/googlemaps';
import { ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
declare var google: any;

import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';


@Component({
  selector: 'app-cq4',
  templateUrl: './cq4.component.html',
  styleUrls: [
    './cq4.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq4Component implements OnInit {
  @Input() data: any;
  @Output() selectOn: EventEmitter<any> = new EventEmitter();
  @ViewChild('Suite', { static: true }) inputEl: ElementRef;
  @ViewChild('Suite_mob', { static: true }) inputEl_mob: ElementRef;
  @ViewChild('places', { static: true }) places: GooglePlaceDirective;
  @ViewChild('search', { static: true }) public searchElement: ElementRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  @ViewChild('noservice', { static: true }) noService: ElementRef;
  @ViewChild('contact', { static: true }) contact: ElementRef;
  @ViewChild('thank', { static: true }) thank: ElementRef;
  @ViewChild('ESIID_not_found_from_REP', { static: true }) ESIID_not_found_from_REP: ElementRef;
  suite = '';
  address;
  formatedAddress;
  question;
  questions;
  userResponses = [];
  esiidResponses = [];
  index;
  Largeheight = 0;
  questionObj;
  messagetype;
  user_bot = false;
  pointer_name;
  rememberQuestion = false;
  esiidQ1 = false;
  isChecked = false;
  no_worries = false;
  addESIID = false;
  typeaheadOnSelect;
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };
  // For ngx-google-autocomplete
  lat;
  lng;
  options = {
    types: [],
    componentRestrictions: { country: 'US' },
  };
  isAddressSelected = false;
  ConfirmDisable = true;
  geoMapAddress;
  deviceWidth;
  showMap = false;
  timer;
  time = 3000;
  typingTimer;
  showTyping = false;
  bounds: google.maps.LatLngBounds;
  markers: google.maps.Marker[];
  infoWindow: google.maps.InfoWindow;
  isDisabled = false;
  esiids = [{ value: '' , text: '', usertype: false}];
  fomattedesiids = [{ value: '' }];
  addresses = [];
  yes_id;
  no_id;
  yes_no;
  esiid_question;
  esiid_timer;
  esiid_yes_id;
  esiid_no_id;
  isExit = false;
  other_esiid;
  showTip = false;
  isHighlight = false;
  show_yes = false;
  show_no = false;
  clicksCount = 1;
  isEditable = false;
  selectedEsiid;
  utilities;
  selectedUtility;
  TypeaheadModule : TypeaheadModule;
  modalRef: BsModalRef;
  zipcode;
  callUtilityAPI = false;
  //help pop-up
  url = environment.api_url;
  userObj = {
    fullName: '',
    emailId: '',
    contactQues: '',
    type: 'contact',
  };
  // Save contact
  contactObj = {
    fullName: '',
    emailId: '',
    question: '',
  };
  display = 'none';
  temperaryUtility;
  esiidIndex;

  public handleAddressChange(address) {
    // this.isAddressSelected = true;

    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
    }
    this.geoMapAddress = address;
    this.commercialService.address = address;
    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }

    this.getFormattedAddress(address);
  }


  public handleAddressChange2(address) {
    // this.isAddressSelected = true;

    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
    }
    this.geoMapAddress = address;
    this.commercialService.address = address;
    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }

    this.getFormattedAddress(address,false);
  }



  constructor(
    private commercialService: CommercialService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private http: HttpClient,
    private _scrollToService: ScrollToService,
    private cd: ChangeDetectorRef,
    private modalService: BsModalService
  ) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
    if (sessionStorage.getItem('clicksCount') !== undefined) {
      this.clicksCount = Number(sessionStorage.getItem('clicksCount'));
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
        this.triggerScrollTo('typing');
      }, 250);
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
      this.showTyping = false;
    }
  }

  markerIconUrl() {
    return require('../../../../../assets/images/map-marker-2.png');
  }

  edit() {
    // if (this.clicksCount < 5) {
       this.isDisabled = false;
    // } else {
    //   this.isDisabled = true;
    // }
    // this.clicksCount = this.clicksCount + 1;
    // if (this.clicksCount >= 5) {
    //   this.isEditable = true;
    // }
    // sessionStorage.setItem('clicksCount', this.clicksCount.toString());

    $('#autocomplete').click();
    $(".autocomplete").addClass('boderClass')
  }

  ChangedAddress(address)
  {
    this.esiidResponses = [];
    $("#focusWeb0").val('')
    $("#focus0").val('')
  }
  handleformatedAddress(address) {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
    }
   
    // // console.log.log(address.length);
    console.log('handle change..', address);
    if (address.length > 1) {
      this.isAddressSelected = true;
    } else if (address != undefined || address != null || address != '') {
      this.isAddressSelected = false;
    } else {
      this.isAddressSelected = true;
    }
    //  // console.log.log("this.isAddressSelected....",this.isAddressSelected);
  }

  changePointerName() {
    this.isDisabled = true;
    this.formatedAddress.name = this.pointer_name;
    this.geoMapAddress.name = this.pointer_name;
    if (_.isEmpty(this.pointer_name)) {
      this.isAddressSelected = false;
    }
  }

  remove(index) {
    this.esiids.splice(index, 1);
    if (this.esiids[this.esiids.length - 1].value !== '') {
      this.addESIID = true;
    }
  }

  showAddEsiid_new() {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
      this.addESIID = true;
      this.triggerScrollTo('add_id');
      this.esiidIndex = this.esiids.length - 1;
     
    }
  }

  showAddEsiid() {
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({ currentId: this.data });
      this.addESIID = true;
      this.triggerScrollTo('add_id');
      this.esiidIndex = this.esiids.length - 1;
      document
        .getElementById('focus' + (this.esiids.length - 1).toString())
        .blur();
      document
        .getElementById('focusWeb' + (this.esiids.length - 1).toString())
        .blur();
    }
  }
  otherESIID(event) {
    if (this.deviceWidth < 768) {
      this.esiid_yes_id = document.getElementById('esiid_yes_mob');
      this.esiid_no_id = document.getElementById('esiid_no_mob');
    }
    this.other_esiid = event;
    if (
      event === 'Yes' &&
      !_.contains(this.esiid_yes_id.classList, 'active-select')
    ) {
      if (_.contains(this.esiid_no_id.classList, 'active-select')) {
        this.esiid_no_id.classList.remove('active-select');
      }
      this.esiid_yes_id.classList.add('active-select');
      this.addESIID = false;
      this.commercialService.unSelectService({ currentId: this.data });
      this.AddEsiid();
    } else if (
      event === 'No' //&&
      //!_.contains(this.esiid_no_id.classList, 'active-select')
    ) {
      // if (_.contains(this.esiid_yes_id.classList, 'active-select')) {
      //   this.esiid_yes_id.classList.remove('active-select');
      // }
      // this.esiid_no_id.classList.add('active-select');
      this.next();
    }
  }

  AddEsiid() {
    if (
      this.esiids.length != 0 &&
      this.esiids[this.esiids.length - 1].value !== ''
    ) {
      if (this.esiids.length === 1) {
        this.esiid_question = this.questionObj.esiid_q1;
      } else {
        this.esiid_question = this.questionObj.esiid_q2;
      }
      this.esiids.push({ value: '' , text: '' , usertype : false});

      if (this.deviceWidth < 768)
      {
       
      }else
      {
        document
        .getElementById('focusWeb' + (this.esiids.length - 1).toString())
        .focus();
      }
   
      this.triggerScrollTo((this.esiids.length - 1).toString());
    } else {
      this.esiids.push({ value: '' , text: '', usertype : false});
    }
  }

  getNext() {
    if (this.isExit) {
      document
        .getElementById('exit')
        .parentElement.classList.add('active-select');
      this.time = 1000;
      this.next(true);
    } else {
      if (
        _.contains(
          document.getElementById('exit').parentElement.classList,
          'active-select'
        )
      ) {
        document
          .getElementById('exit')
          .parentElement.classList.remove('active-select');
      }
      this.commercialService.unSelectService({ currentId: this.data });
    }
  }

  getFormattedAddress(place, callAPI = true) {
    this.formatedAddress = place.formatted_address;

    if(callAPI)
    {

    
    if (place.formatted_address) {
      this.pointer_name = place.name;
    } else {
      this.pointer_name = '';
    }
  }
    let addressValue = '';
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[i][this.componentForm[addressType]];
        addressValue = addressValue + addressType + ':' + val + ';';
      }
      if (place.address_components[i].types[0] === 'postal_code') {
        this.zipcode = place.address_components[i].long_name;
      }
    }
    if (!this.callUtilityAPI && callAPI) {
      $("#focusWeb0").val('')
      this.ConfirmDisable = false;
      $("#focus0").val('')
      this.commercialService.getUtilies(this.zipcode,this.formatedAddress).subscribe((response) => {
        this.ConfirmDisable = true;
        if (
          response['statusCode'] === '001' &&
          response['statusText'] === 'success' &&
          response['data'].length > 0
        ) {
          if (response['data'].length > 1) {
            this.utilities = response['data'];
            this.openModal(this.template);
          } else {
            this.selectedUtility = response['data'][0].Utility;
            this.isAddressSelected = true;
            if (this.deviceWidth < 768){

              this.isChecked =false;
             
            }
            if(response['esidObj'] == undefined || response['esidObj'] == '' || response['esidObj'] == null)
            {
              this.openModal(this.ESIID_not_found_from_REP);
              //this.isAddressSelected = false;
              this.esiidResponses = [];

            }else
            {
              this.loadESIIDValues(response['esidObj']);
            }
            
          }
        } else {
          this.openModal(this.noService);
          this.isAddressSelected = false;
          this.esiidResponses = [];
        }
      });
    } else {
      this.isAddressSelected = true;
    }
    this.address = addressValue;
    this.showMap = true;
    this.showTip = true;
    $("#tooltip").css("visibility","visible")
    this.isDisabled = true;
    this.triggerScrollTo('remember');
  }

  loadESIIDValues(result) {
    if (
      result === 'Requested data not found' ||
      result === '' ||
      result === 'Zip Code is Invalid' ||
      result === 'Addresses Not Found' ||
      result === 'Invalid address character' ||
      result === 'Zip code must be five digits long' ||
      result[0] === 'Requested data not found' ||
      result[0] === 'Zip code must be five digits long'
    ) {
      // this.esiid_value = 'ESI ID # Locator  Currently Unavailable';
       this.selectedEsiid = 'ESI ID # Locator  Currently Unavailable';
      // this.enableESIDInput = true;
    } else {
      if (result.length > 0 && result[0] != 'Requested data not found') {
        const value = this.concatenateAddressWithEsiid(result);
        this.esiidResponses = value;
        // this.showCredits = '';
        // this.enableESIDInput = false;


        if (this.deviceWidth < 768){

          for(var i=0; i < this.esiidResponses.length; i++ )
          {
            if( this.esiidResponses[i] !== '' && this.esiidResponses[i].indexOf('–') > -1)
            {
              this.esiidResponses[i] = this.esiidResponses[i].split('–')[0]
             
            }
          }
        }

        var esiid = this.esiidResponses[0];
        if(this.esiidResponses[0].indexOf('–') > -1 )
        {
          esiid =  this.esiidResponses[0].split('–')[0]
          

         }//else
        // {
          this.selectedEsiid = esiid
          if(this.esiidResponses.length == 1)
          {

              if(this.esiids.length == 0)
                        {
                          this.esiids.push({ value: this.esiidResponses[0],//esiid, 
                            text: this.esiidResponses[0], usertype: false  });
              
                        }else
                        {
                          if (this.deviceWidth < 768)
                          {
                           
                            this.esiids[0].value = esiid;//esiid;
                            this.esiids[0].text = this.esiidResponses[0];
                            this.esiids[0].usertype = false
                          }else
                          {

                            this.esiids[0].value = this.esiidResponses[0];//esiid;
                            this.esiids[0].text = this.esiidResponses[0];
                            this.esiids[0].usertype = false

                          }


                        }
                        $("#focusWeb0").val(this.esiidResponses[0])
                        $("#focus0").val(esiid)
          }else

          {
            $("#focusWeb0").val('')
            $("#focusWeb0").click()
          }
          
          if (this.deviceWidth < 768){

            this.isChecked =true;
            this.confirm();
          }
          
    
         
        // this.esiid_value = this.esiidResponses[0].split('-')[0];
        // this.newFormattedAddress = this.esiidResponses[0].split('-')[1];
        // this.residentialService.esiid = this.esiid_value;
        // this.formatedAddress = this.newFormattedAddress;
        // this.residentialService.newFormattedAddress =
        //   this.esiidResponses[0].split('-')[1];
       
      }
  
    }
  }

  concatenateAddressWithEsiid(result: any) {
    const addressDetails: any = [];
    result.map((res) => {
      if (res.Addresses) {
        res.Addresses.map((row) => {
          addressDetails.push(`${row.ESIID}–${row.FullAddress}`);
        });
      }
    });
    return addressDetails;

    // const addressDetails = [];
    // result[0].Addresses.map((row) => {
    //   addressDetails.push(`${row.ESIID}-${row.FullAddress}`);
    // });
    // return addressDetails;
  }
  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }

  closeModal() {
    this.selectedUtility = this.temperaryUtility;
    this.isAddressSelected = true;
    this.modalRef.hide();
    this.openModal(this.contact);
  }

  selectUtility(utility) {
    this.temperaryUtility = utility;
    const existingElements = document.getElementsByClassName('active-select');
    _.each(existingElements, function (item) {
      item.classList.remove('active-select');
    });
    const elem = document.getElementById(utility);
    elem.classList.add('active-select');
  }

  closeModalWithOutContact() {
    this.selectedUtility = this.temperaryUtility;
    this.isAddressSelected = true;
    this.modalRef.hide();
  }

  confirm() {
    if (this.isChecked && this.isAddressSelected) {
      document
        .getElementById('confirm')
        .parentElement.classList.add('active-select');
      this.triggerScrollTo('remember');
      this.isHighlight = true;
    } else {
      if (
        _.contains(
          document.getElementById('confirm').parentElement.classList,
          'active-select'
        )
      ) {
        document
          .getElementById('confirm')
          .parentElement.classList.remove('active-select');
      }
      this.commercialService.unSelectService({ currentId: this.data });
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  getAcceptance(event) {
    if (this.deviceWidth < 768) {
      this.yes_id = document.getElementById('yes_mob');
      this.no_id = document.getElementById('no_mob');
    }

    if (
      event === 'Yes' &&
      !_.contains(this.yes_id.classList, 'active-select')
    ) {
      this.commercialService.unSelectService({ currentId: this.data });
      if (_.contains(this.no_id.classList, 'active-select')) {
        this.no_id.classList.remove('active-select');
      }
      this.yes_id.classList.add('active-select');
      this.yes_no = 'Hang tight, I’ll go get them for you right now';
      this.show_no = false;
      this.show_yes = true;
      //this.esiids = [{ value: '' }];
      if (
        this.esiids.length >= 1 &&
        !_.isEmpty(this.esiids[this.esiids.length - 1].value)
      ) {
        this.addESIID = true;
      }
      this.show_no = false;
      this.triggerScrollTo('yes');
    } else if (
      event === 'No' &&
      !_.contains(this.no_id.classList, 'active-select')
    ) {
      this.commercialService.unSelectService({ currentId: this.data });
      if (_.contains(this.yes_id.classList, 'active-select')) {
        this.yes_id.classList.remove('active-select');
      }
      this.no_id.classList.add('active-select');
      this.yes_no = 'I’ll be sure to email them as soon as I can';
      this.show_yes = false;
      this.addESIID = false;
      this.triggerScrollTo('typing');
      this.show_no = true;
      this.show_yes = false;
      this.no_worries = true;
      this.triggerScrollTo('no');
    }
  }

  ngOnInit() {
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    $(".autocomplete").focusout(function(){
      $(this).removeClass('boderClass')
      
    })

    $('.typeahead').on('typeahead:selected', function(evt, item) {
      console.log('s')
    })
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.selectOn.emit(this.getFormattedAddress(autocomplete.getPlace()));
      // }
    });

    const autocomplete2 = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete2'),
      { types: ['geocode'] }
    );
    google.maps.event.addListener(autocomplete2, 'place_changed', () => {
      this.selectOn.emit(this.getFormattedAddress(autocomplete2.getPlace()));
      // }
    });
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.yes_id = document.getElementById('yes_mob');
      this.no_id = document.getElementById('no_mob');
      this.esiid_yes_id = document.getElementById('esiid_yes_mob');
      this.esiid_no_id = document.getElementById('esiid_no_mob');
    } else {
      this.yes_id = document.getElementById('yes');
      this.no_id = document.getElementById('no');
    }
    if (this.esiids.length === 1) {
      this.esiid_question = this.questionObj.esiid_q1;
    } else {
      this.esiid_question = this.questionObj.esiid_q2;
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        if (!_.isEmpty(obj.fieldValue)) {
          this.addresses = obj.fieldValue;
          if (
            !this.commercialService.addAddress &&
            !_.isEmpty(this.addresses)
          ) {
            let index;
            if (this.commercialService.serialNumber === null) {
              index = this.addresses.length - 1;
            } else if (this.commercialService.serialNumber !== null) {
              index = this.commercialService.serialNumber;
            }
            if (!_.isEmpty(this.addresses[index])) {
              this.callUtilityAPI = true;
              this.address = this.addresses[index].address;
              this.suite = this.addresses[index].suite;
              this.formatedAddress = this.addresses[index].formatedAddress;
              this.geoMapAddress = this.addresses[index].geoMapAddress;
              this.esiids = this.addresses[index].esiids;

              var esiids = this.esiids.map(a => a.text);
              esiids = esiids.filter(x => x != "");
              this.esiidResponses = esiids;

              for(var i=0; i < this.esiids.length; i++ )
              {
                if( this.esiids[i].text !== '')
                {
                  this.esiids[i].value = this.esiids[i].text;
                 
                }
              }

              this.selectedUtility = this.addresses[index].utility;
              this.handleAddressChange(this.geoMapAddress);
              this.pointer_name = this.addresses[index].pointer_name;
              this.isChecked = this.addresses[index].isChecked;
              // this.confirm();
              this.yes_no = this.addresses[index].yes_no;
              if (!_.isEmpty(this.yes_no)) {
                this.no_worries = true;
                if (
                  this.yes_no ===
                  'Hang tight, I’ll go get them for you right now'
                ) {
                  this.show_yes = true;
                  this.show_no = false;
                } else if (
                  this.yes_no === 'I’ll be sure to email them as soon as I can'
                ) {
                  this.show_no = true;
                  this.show_yes = false;
                  this.addESIID = false;
                }
              }
              this.other_esiid = this.addresses[index].other_esiid;
              this.addESIID = this.addresses[index].addESIID;
              if (!_.isEmpty(this.other_esiid)) {
                if (this.other_esiid === 'No') {
                  this.goNext();
                } else if (this.other_esiid === 'Yes') {
                  this.addESIID = false;
                  this.AddEsiid();
                }
              }
              this.isExit = this.addresses[index].is_exit;
              this.isHighlight = true;
              this.user_bot = true;
            }
          }
        }
      }
    }
  }

  ngAfterViewChecked(): void {

    if (this.deviceWidth < 768)
    {

    }else
    {

      try{
        if (this.isHighlight) {
          this.yes_id = document.getElementById('yes_mob');
          this.no_id = document.getElementById('no_mob');
          this.esiid_yes_id = document.getElementById('esiid_yes_mob');
          this.esiid_no_id = document.getElementById('esiid_no_mob');
          if (this.isChecked) {
            document
              .getElementById('confirm')
              .parentElement.classList.add('active-select');
            if (!_.isEmpty(this.yes_no)) {
              if (
                this.yes_no === 'Hang tight, I’ll go get them for you right now'
              ) {
                this.show_yes = true;
                this.getAcceptance('Yes');
              } else if (
                this.yes_no === 'I’ll be sure to email them as soon as I can'
              ) {
                this.getAcceptance('No');
              }
            }
          }
          if (this.esiid_yes_id !== null && this.other_esiid === 'Yes') {
            this.esiid_yes_id.classList.add('active-select');
            this.addESIID = false;
            this.AddEsiid();
          } else if (this.esiid_no_id !== null && this.other_esiid === 'No') {
            this.esiid_no_id.classList.add('active-select');
            if (this.commercialService.modifyAddress) {
              this.goNext();
            } else {
              this.next();
            }
          }
          if (this.isExit) {
            document
              .getElementById('exit')
              .parentElement.classList.add('active-select');
            if (this.commercialService.modifyAddress) {
              this.goNext();
            } else {
              this.next();
            }
          }
          this.isHighlight = false;
        }
      }catch{

      }
     
    }

  }

  next(gonext = false) {
    this.address = this.formatedAddress;
    if (
      _.isEmpty(this.address) ||
      !this.isAddressSelected ||
      _.isEmpty(this.pointer_name) ||
      _.isEmpty(this.selectedUtility)
    ) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({ currentId: this.data });
      }
    } else {
      
      var check =_.filter(this.esiids, function (item) {
        return item.value !== '';
      });
      if(check.length == 0)
      {

        $("#focusWeb0").click();
        if(!gonext)
        {
          return;

        }
      }

      if(check.length != this.esiids.length)
      {
        var index = 0
        var check_ =_.filter(this.esiids, function (i,item) {
           
          if( i.value === '')
          {
            index = item
            return item;
          }
        });


        $("#focusWeb"+index).click();
        if(!gonext)
        {
          return;

        }
      }

      
      var Isvalid = true;
      for(var i=0; i < this.esiids.length; i++ )
      {
        if( this.esiids[i].value !== '' &&  this.esiids[i].usertype  &&  !this.ValidateEsiid( this.esiids[i].value,i) )
        {
          Isvalid = false
         
        }
      }

      if(!Isvalid)
      {
        if(!gonext)
        {
          return;

        }
      }

      this.esiids = _.filter(this.esiids, function (item) {
        return item.value !== '';
      });

      for(var i=0; i < this.esiids.length; i++ )
      {
        if(this.esiids[i].value.indexOf('–') > -1)
        {
          if(this.esiids[i].text == '' && this.esiids[i].usertype == false)
          {
            this.esiids[i].text = this.esiids[i].value;
          }
          this.esiids[i].value = this.esiids[i].value.split('–')[0];
        }
      }


      var isAddressChanged = false;

      if (this.commercialService.serialNumber === null) {
        this.addresses.push({
          serialNo: this.addresses.length + 1,
          address: this.address,
          formatedAddress: this.formatedAddress,
          suite: this.suite,
          geoMapAddress: this.geoMapAddress,
          utility: this.selectedUtility,
          esiids: this.esiids,
          pointer_name: this.pointer_name,
          isChecked: this.isChecked ? this.isChecked : true,
          yes_no: this.yes_no ? this.yes_no : '',
          addESIID: this.addESIID ? this.addESIID : false,
          other_esiid: this.other_esiid ? this.other_esiid : '',
          is_exit: this.isExit ? this.isExit : false,
        });

        isAddressChanged = true;
      } else {
        var currentAddress =
          this.addresses[this.commercialService.serialNumber];

        // if (
        //   currentAddress.address != this.address ||
        //   currentAddress.formatedAddress != this.formatedAddress ||
        //   currentAddress.suite != this.suite
        // ) {
        //   isAddressChanged = true;
        // }

        this.addresses[this.commercialService.serialNumber] = {
          serialNo: this.commercialService.serialNumber + 1,
          address: this.address,
          formatedAddress: this.formatedAddress,
          suite: this.suite,
          geoMapAddress: this.geoMapAddress,
          utility: this.selectedUtility,
          esiids: this.esiids,
          pointer_name: this.pointer_name,
          isChecked: this.isChecked ? this.isChecked : true,
          yes_no: this.yes_no ? this.yes_no : '',
          addESIID: this.addESIID ? this.addESIID : false,
          other_esiid: this.other_esiid ? this.other_esiid : '',
          is_exit: this.isExit ? this.isExit : false,
        };
      }
      const Obj = {
        com_question_id: this.data,
        fieldName: 'address',
        fieldValue: this.addresses,
      };
      this.user_bot = true;
      this.commercialService.updateResponses(Obj);

      if (this.commercialService.serialNumber == null) {
        this.commercialService.serialNumber = this.addresses.length - 1;
      }
      this.commercialService.addAddress = false;

      if (isAddressChanged) {
        this.commercialService.messageService({ currentId: this.data });
      } else {
        if (this.commercialService.modifyAddress) {
          for (let i = 0; i < this.questions.length; i++) {
            if (this.questions[i]._id === '0011') {
              this.commercialService.messageService({ currentId: '0011' });
            } else if (this.questions[i]._id === '0013') {
              this.commercialService.messageService({ currentId: '0014' });
            }
          }

          if (this.userResponses[11].fieldValue.length > 0)
            this.commercialService.messageService({ currentId: '0011' });
          else if (this.userResponses[13].fieldValue.length > 0)
            this.commercialService.messageService({ currentId: '0013' });
        } else {
          this.commercialService.messageService({ currentId: this.data });
        }
      }
    }
  }

  // To set the validation flag on editting the i/p
  setFlag() {
    this.isAddressSelected = false;
    this.callUtilityAPI = false;
    if (!this.isAddressSelected) {
      this.pointer_name = '';
    }
  
    // $('html, body').animate(
    //   { scrollTop: $(document).height()  },
    //   0
    // );
    
    // if($(document).height() >  this.Largeheight)
    // {
    //   this.Largeheight = $(document).height();
    //   var h = this.Largeheight;
    //   $('html, body').animate(
    //     { scrollTop: h },
    //     0
    //   );

      
    // }else
    // {
    //   $('html, body').animate(
    //     { scrollTop: $(document).height()  },
    //     0
    //   );
    // }
  
  }

  //help pop-up
  send(event, myForm, formValid, modalId) {
    if (formValid) {
      this.modalRef.hide();
      this.contactObj.fullName = this.userObj.fullName;
      this.contactObj.emailId = this.userObj.emailId;
      this.contactObj.question = this.userObj.contactQues;

      const saveContactParam = new HttpParams().append(
        'contactObj',
        JSON.stringify(this.contactObj)
      );

      myForm.resetForm();
      const elementObj = document.getElementById(modalId);
      this.display = 'block';

      this.http
        .post(this.url + '/saveContact', saveContactParam)
        .subscribe((res: any) => {
          this.onCloseHandled();
          const saveContactResponse = res;
          this.modalRef.hide();
          this.openModal(this.thank);
        });
    }
  }

  closeContactModal(form) {
    this.modalRef.hide();
    form.resetForm();
  }

  closeResetModal() {
    this.modalRef.hide();
    this.isAddressSelected = false;
  }
  onCloseHandled() {
    this.display = 'none';
  }

ConfirmAddress()
{

  if(!this.ConfirmDisable)
  {

    return;
  }
  $("#focusWeb0").val('')
  $("#focus0").val('')
  var obj = this.getFormattedAddressByState(this.formatedAddress,'');

  if(obj != '')
  {
    var zip = obj['zipcode'];
    // if(zip != '')
    // {
      this.commercialService.getUtilies(zip,this.formatedAddress).subscribe((response) => {
        if (
          response['statusCode'] === '001' &&
          response['statusText'] === 'success' &&
          response['data'].length > 0
        ) {
          if (response['data'].length > 1) {
            this.utilities = response['data'];
            this.openModal(this.template);
          } else {
            this.selectedUtility = response['data'][0].Utility;
            this.isAddressSelected = true;
            
            if (this.deviceWidth < 768){

              this.isChecked =false;
             
            }
            if(response['esidObj'] == undefined || response['esidObj'] == '' || response['esidObj'] == null)
            {
              this.openModal(this.ESIID_not_found_from_REP);
              //this.isAddressSelected = false;
              this.esiidResponses = [];

            }else
            {
              this.loadESIIDValues(response['esidObj']);
            }

            if(this.geoMapAddress != undefined)
            {
              this.geoMapAddress.formatted_address = this.formatedAddress;

            }



          }
        } else {
          this.openModal(this.noService);
          this.isAddressSelected = false;
          this.esiidResponses = [];
        }
      });

    //}
  

  }

  

}


getFormattedAddressByState(address,apt) {
  let temp_address = {};
  try{
   
    let address_ = address;
    if (address_ != "" && address_ != "undefined") {
      let address = address_.split(',');
      let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
      if (address[0].toUpperCase().indexOf('APT') > 1) {
        temp_address['street_address'] = address[0].substring(
          0,
          address[0].toUpperCase().indexOf('APT') - 1
        );
        temp_address['apartment'] = address[0].substring(address[0].toUpperCase().indexOf('APT') + 4);
      } else {
        temp_address['street_address'] = address[0];
        temp_address['apartment'] = apt;
      }
      temp_address['city'] = address[1] ? address[1].trim() : '';
      temp_address['state'] = state ? state : '';
      temp_address['zipcode'] = zipcode ? zipcode : '';
    }
    return temp_address;

  }catch{
  
   
    return '';


  }

}
Changed(i,text)
{
// var a ;
// this.esiids[i].text = text;
// this.esiids[i].value = text.split('–')[0];
this.showAddEsiid_new()
}

EditESIID(i,v)
{ 
 // this.addESIID =  false;
  var fieldname = '#focusWeb'; 
  if (this.deviceWidth < 768)
  {
    fieldname = '#focus'; 
  }

  $("#ErrorMsg" + i).text('');
  $("#ErrorMsgMob" + i).text('');
  
  this.esiids[i].usertype = false
  var a = $(fieldname + i).val()

  if(a != '' && $(fieldname + i).val() != v)
  {
    if(this.esiidResponses.indexOf($(fieldname + i).val()) == -1)
    {
      this.esiids[i].usertype = true
      var aa = this.ValidateEsiid($(fieldname + i).val(),i)

      if(aa)
      {
        if (this.deviceWidth < 768) {
        this.showAddEsiid_new()
        }
      }
      
    }
   
  }

 
  if(this.esiids[i].usertype == false && fieldname == '#focus')
  {
    // this.esiids[i].text = this.esiids[i].text;

    var val = $(fieldname + i).val().toString();
    if(val.indexOf('–') > -1)
    {
      this.esiids[i].value = val.split('–')[0];
      $(fieldname + i).val(val.split('–')[0])
    }

    if($(fieldname + i).val() != '')
    {
      this.showAddEsiid_new()

    }
    // this.esiids[i].value = this.esiids[i].value;
  }
  
}

ValidateEsiid(value, index)
{

  var result = false;
  if(!_.isEmpty(this.selectedUtility))
  {
    var mxlength = 17;
    var Prefix = 10;
    var code = "";
    if(this.selectedUtility == "CenterPoint" || this.selectedUtility =='CenterPoint Energy')
    {
      mxlength = 22;
      code = "08901";
    }
    if(this.selectedUtility == "Oncor")
    {
      code = "44372";
    }
    if(this.selectedUtility == "AEPC" || this.selectedUtility == "AEP Texas Central")
    {
      
      code = "03278";
    }

    if(this.selectedUtility == "AEPN" || this.selectedUtility == "AEP Texas North")
    {
      code = "20404";
    }
    if(this.selectedUtility == "TNMP"|| this.selectedUtility == "Texas New Mexico Power")
    {
      code = "40051";
     
    }

    var validate = false;
    if(value.substring(0, 2).indexOf(Prefix) > -1)
    {
      validate = true;
    }

    if(value.substring(2, 7).indexOf(code) > - 1 && validate)
    {
      validate = true;
    }else
    {
      validate = false;
    }

    if(mxlength == value.length && validate)
    {
      validate = true;
    }else
    {
      validate = false;
    }

    if(validate)
    {
      validate = $.isNumeric( value ); 
    }
     
    if(validate == false)
    {
      $("#ErrorMsg" + index).text('Please enter a valid ESIID.');
      $("#ErrorMsgMob" + index).text('Please enter a valid ESIID.');
      
    }
    result = validate;

  }else
  {
    $("#ErrorMsg" + index).text('Please select your address first.');
    $("#ErrorMsgMob" + index).text('Please select your address first.');
  }
 return result;
}
}
